export const DEMOSNAPSHOT = 'https://testnet.snapshot.org/graphql';
export const PRODUCTIONSNAPSHOT = 'https://hub.snapshot.org/graphql';
export const SNAPSHOTJS = 'https://hub.snapshot.org';
